// TODO: move to this file once the it's not used in ember anymore
import Notifications from '../../components/core/notifications';

export default Notifications;
